export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_green-membership/artifacts/43rfn5v5_12DC6DC5-1B11-4BD4-959D-80893816928A-removebg-preview.png";

export const MENU = {
  specialty: {
    eyebrow: "Specialty · Uji",
    title: "Gokou × Samidori",
    grade: "First-flush, hand-picked, stone-milled in Uji.",
    notes:
      "Two cultivars blended on the farm — Gokou for depth and umami, Samidori for the clean, lingering sweetness. Vivid jade, no milk, no sugar.",
    pricing_note: "Specialty grade · full price always",
    items: [
      {
        name: "Usucha",
        desc: "An acquired taste. Deep and savoury — umami-rich with a velvety, lingering finish.",
        price: 400,
        image: "/menu/usucha.png",
      },
      {
        name: "Iced Matcha Latte (Uji)",
        desc: "Uji specialty matcha shaken with house-blend oat milk — bright, vegetal, faintly sweet.",
        price: 499,
        image: "/menu/iced-latte-light.png",
      },
    ],
  },
  everyday: {
    eyebrow: "Everyday · Shizuoka",
    title: "Single-farm Shizuoka",
    grade: "First-harvest, custom-blended cultivars from a young Shizuoka farmer.",
    notes:
      "Rounder, slightly more robust — built to hold its own against milk, ice and fruit. The grade behind everything below, and the one your pass applies to.",
    pricing_note: "Pass discounts apply",
    items: [
      {
        name: "Iced Matcha Latte",
        desc: "Mellow and creamy, with a dash of maple and house-blend oat milk.",
        price: 380,
        image: "/menu/iced-latte.png",
      },
      {
        name: "Strawberry Matcha Latte",
        desc: "Home-made strawberry purée with house-blend oat milk. Tart-sweet.",
        price: 420,
        image: "/menu/strawberry.png",
      },
      {
        name: "Mango Matcha Latte",
        desc: "Home-made mango purée slow-simmered with ripe Alphonso. Tropical and creamy.",
        price: 440,
        image: "/menu/mango.png",
      },
      {
        name: "Pear Matcha Latte",
        desc: "Home-poached pears with vanilla and honey. Delicate and softly sweet.",
        price: 450,
        image: "/menu/pear.png",
      },
      {
        name: "Double Banana Bread Foam Latte",
        desc: "Warm caramelised banana with espresso and an airy banana-bread foam, freshly whipped.",
        price: 430,
        image: "/menu/banana.png",
      },
    ],
  },
};
